(function () {
  'use strict';

  var root = document.querySelector('[data-sm-showroom]');
  if (!root) return;

  document.documentElement.classList.add('sm-showroom-page');

  var DEFAULT_MAKE = 'Subaru';
  var LAST_VEHICLE_KEY = 'sm-sr-last-vehicle';
  var YMM_TAG_RE = /^YMM_(\d{4})_(.+)$/;
  var OTHER_CATEGORY = 'Other';
  var MERCH_COLLECTION_HANDLE = 'subimods-merch';
  var MERCH_TYPES = [
    { type: 'Stickers And Vinyls', label: 'Stickers And Vinyls' },
    { type: 'Shirts', label: 'Shirts' },
    { type: 'Hats', label: 'Hats' },
    { type: 'Sweatshirts', label: 'Sweatshirts' },
    { type: 'License Plate Frames, Exterior Trim Pieces', label: 'License Plate Frames' },
    { type: 'Key Chains and Lanyards', label: 'Key Chains and Lanyards' },
    { type: 'Reading Magazine', label: 'Reading Magazine' }
  ];
  var MERCH_TYPE_BY_KEY = {};
  MERCH_TYPES.forEach(function (spec) {
    MERCH_TYPE_BY_KEY[spec.type] = spec;
  });
  var MERCH_SIZE_TYPES = { Shirts: 1, Sweatshirts: 1 };
  var MERCH_SIZE_ORDER = {
    'extra small': 10, xs: 10,
    small: 20, s: 20,
    medium: 30, m: 30,
    large: 40, l: 40,
    'x-large': 50, xl: 50,
    '2xl': 60, xxl: 60,
    '3xl': 70,
    '4xl': 80,
    '5xl': 90,
    '6xl': 100,
    'kids size 2': 200,
    'kids size 4': 210,
    'kids size 8': 220,
    'kids size 12': 230,
    'size 2': 300,
    'size 4': 310,
    'size 8': 320,
    'size 12': 330
  };
  var GRID_PAGE_SIZE = 60;
  var GRID_LOAD_MORE = 20;
  var SHOP_ORDER_TAG = 'SM Shop';
  var SHOP_CART_KEY = '_sm_shop';
  var SEARCH_TYPE_PILL_MAX = 10;
  var SEARCH_STOP = {
    a: 1, an: 1, and: 1, at: 1, by: 1, for: 1, from: 1, in: 1, into: 1,
    is: 1, it: 1, my: 1, of: 1, on: 1, or: 1, our: 1, part: 1, parts: 1,
    product: 1, products: 1, the: 1, this: 1, that: 1, to: 1, with: 1, your: 1
  };

  var ymmIndex = {};
  var ymmByToken = {};
  var products = [];
  var catalogReady = false;
  var catalogError = false;
  var lightboxLastFocus = null;
  var searchPool = [];
  var searchPoolYmm = '';
  var searchRaf = 0;

  var config = {
    collectionHandle: 'all-products-inventory',
    collectionId: 304450207919,
    collectionSource: 'fallback',
    pageSize: 250,
    productsCount: 0
  };
  try {
    var configEl = document.getElementById('sm-sr-config');
    if (configEl) config = Object.assign(config, JSON.parse(configEl.textContent || '{}'));
  } catch (err) {
    /* keep defaults */
  }

  try {
    var ymmMapEl = document.getElementById('sm-sr-ymm-map-data');
    var ymmMap = ymmMapEl ? JSON.parse(ymmMapEl.textContent || '[]') : [];
    if (Array.isArray(ymmMap)) {
      ymmMap.forEach(function (row) {
        if (!row || !row.ymm) return;
        ymmByToken[row.ymm] = row;
      });
    }
  } catch (err) {
    ymmByToken = {};
  }

  var state = {
    screen: 'ymm',
    ymm: null,
    vehicle: '',
    allProducts: false,
    category: null,
    mode: 'category',
    query: '',
    vendor: '',
    type: '',
    size: '',
    visibleCount: GRID_PAGE_SIZE,
    lightboxProductId: null
  };

  var yearEl = root.querySelector('[data-sr-year]');
  var makeEl = root.querySelector('[data-sr-make]');
  var modelEl = root.querySelector('[data-sr-model]');
  var formEl = root.querySelector('[data-sr-ymm-form]');
  var noticeEl = root.querySelector('[data-sr-notice]');
  var continueEl = root.querySelector('[data-sr-continue]');
  var searchAllEl = root.querySelector('[data-sr-search-all]');
  var loadEl = root.querySelector('[data-sr-load]');
  var backEl = root.querySelector('[data-sr-back]');
  var backLabelEl = root.querySelector('[data-sr-back-label]');
  var cartEl = root.querySelector('[data-sr-cart]');
  var cartCountEl = root.querySelector('[data-sr-cart-count]');
  var catsEl = root.querySelector('[data-sr-cats]');
  var catsEmptyEl = root.querySelector('[data-sr-cats-empty]');
  var catsLoadEl = root.querySelector('[data-sr-cats-load]');
  var vehicleEls = root.querySelectorAll('[data-sr-vehicle], [data-sr-vehicle-rail]');
  var railTitleEl = root.querySelector('[data-sr-rail-title]');
  var countEl = root.querySelector('[data-sr-count]');
  var browseEl = root.querySelector('[data-sr-browse]');
  var railFiltersEl = root.querySelector('[data-sr-rail-filters]');
  var railSearchEl = root.querySelector('[data-sr-rail-search]');
  var searchFormEl = root.querySelector('[data-sr-search-form]');
  var searchEl = root.querySelector('[data-sr-search]');
  var vendorEl = root.querySelector('[data-sr-vendor]');
  var vendorFilterEl = root.querySelector('[data-sr-vendor-filter]');
  var sizeEl = root.querySelector('[data-sr-size]');
  var sizeFilterEl = root.querySelector('[data-sr-size-filter]');
  var typesEl = root.querySelector('[data-sr-types]');
  var typeSelectEl = root.querySelector('[data-sr-type-select]');
  var typeFilterEl = root.querySelector('[data-sr-type-filter]');
  var gridEl = root.querySelector('[data-sr-grid]');
  var moreEl = root.querySelector('[data-sr-more]');
  var loadMoreEl = root.querySelector('[data-sr-load-more]');
  var emptyEl = root.querySelector('[data-sr-empty]');
  var searchIdleEl = root.querySelector('[data-sr-search-idle]');
  var searchIdleTilesEl = root.querySelector('[data-sr-search-idle-tiles]');
  var searchIdleKey = '';
  var lightboxEl = root.querySelector('[data-sr-lightbox]');
  var lightboxImageEl = root.querySelector('[data-sr-lightbox-image]');
  var lightboxThumbsEl = root.querySelector('[data-sr-lightbox-thumbs]');
  var lightboxVendorEl = root.querySelector('[data-sr-lightbox-vendor]');
  var lightboxTitleEl = document.getElementById('sm-sr-lightbox-title');
  var lightboxPriceEl = root.querySelector('[data-sr-lightbox-price]');
  var lightboxReviewsEl = root.querySelector('[data-sr-lightbox-reviews]');
  var lightboxScrollEl = root.querySelector('[data-sr-lightbox-scroll]');
  var lightboxDescEl = root.querySelector('[data-sr-lightbox-desc]');
  var lightboxVariantEl = root.querySelector('[data-sr-lightbox-variant]');
  var lightboxVariantWrap = root.querySelector('[data-sr-lightbox-variant-wrap]');
  var lightboxAtcEl = root.querySelector('[data-sr-atc]');
  var STAR_SVG = '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M10 1.6 12.7 7l6 .9-4.4 4.2 1 5.9L10 15.2 4.7 18l1-5.9L1.3 7.9 7.3 7 10 1.6Z"/></svg>';

  function absUrl(value) {
    var url = String(value || '').trim();
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isPhone() {
    return window.matchMedia && window.matchMedia('(max-width: 820px)').matches;
  }

  function uniqueSorted(values) {
    var seen = {};
    var out = [];
    (values || []).forEach(function (value) {
      var key = String(value || '').trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(key);
    });
    return out.sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function productYmmTags(product) {
    var tags = Array.isArray(product.tags) ? product.tags : [];
    return tags.filter(function (tag) {
      return YMM_TAG_RE.test(String(tag || ''));
    });
  }

  function isMerchCatalog() {
    return String(config.collectionHandle || '') === MERCH_COLLECTION_HANDLE;
  }

  function merchTypeSpec(type) {
    return MERCH_TYPE_BY_KEY[String(type || '').trim()] || null;
  }

  function categoryLabel(name) {
    var spec = isMerchCatalog() ? merchTypeSpec(name) : null;
    return spec ? spec.label : (name || '');
  }

  function isMerchSizeCategory() {
    return isMerchCatalog() && state.mode === 'category' && !!MERCH_SIZE_TYPES[state.category];
  }

  function merchSizeRank(size) {
    var key = String(size || '').trim().toLowerCase();
    return MERCH_SIZE_ORDER[key] != null ? MERCH_SIZE_ORDER[key] : 1000;
  }

  function uniqueSizes(values) {
    var seen = {};
    var out = [];
    (values || []).forEach(function (value) {
      var key = String(value || '').trim();
      if (!key || /^default title$/i.test(key) || seen[key]) return;
      seen[key] = true;
      out.push(key);
    });
    return out.sort(function (a, b) {
      var diff = merchSizeRank(a) - merchSizeRank(b);
      if (diff) return diff;
      return a.localeCompare(b);
    });
  }

  function productAvailableSizes(product) {
    var list = [];
    (product && product.variants ? product.variants : []).forEach(function (variant) {
      if (!variant || variant.available !== true) return;
      var title = String(variant.title || '').trim();
      if (!title || /^default title$/i.test(title)) return;
      list.push(title);
    });
    return list;
  }

  function productHasSize(product, size) {
    if (!size) return true;
    return productAvailableSizes(product).indexOf(size) !== -1;
  }

  function productCategories(product) {
    if (isMerchCatalog()) {
      var spec = merchTypeSpec(product && product.type);
      return spec ? [spec.type] : [];
    }
    var list = Array.isArray(product.categories) ? product.categories : [];
    var cleaned = list.map(function (item) {
      return String(item || '').trim();
    }).filter(Boolean);
    return cleaned.length ? cleaned : [OTHER_CATEGORY];
  }

  function isAvailable(product) {
    return product && product.available === true;
  }

  function matchesVehicle(product) {
    if (state.allProducts || isMerchCatalog()) return true;
    if (!state.ymm) return false;
    var tags = productYmmTags(product);
    if (!tags.length) return true;
    return tags.indexOf(state.ymm) !== -1;
  }

  function vehicleProducts() {
    return products.filter(function (product) {
      if (!isAvailable(product) || !matchesVehicle(product)) return false;
      if (isMerchCatalog() && !merchTypeSpec(product.type)) return false;
      return true;
    });
  }

  function categoryProducts() {
    return vehicleProducts().filter(function (product) {
      return productCategories(product).indexOf(state.category) !== -1;
    });
  }

  function productSkuList(product) {
    if (product._skus) return product._skus;
    var seen = {};
    var list = [];
    function add(value) {
      var sku = String(value || '').trim().toLowerCase();
      if (!sku || seen[sku]) return;
      seen[sku] = true;
      list.push(sku);
    }
    add(product.sku);
    (product.variants || []).forEach(function (variant) {
      if (!variant) return;
      add(variant.sku);
      add(variant.barcode);
    });
    product._skus = list;
    return list;
  }

  function productSearchText(product) {
    if (product._q) return product._q;
    var parts = [product.title, product.vendor, product.type, product.handle]
      .concat(productCategories(product))
      .concat(productSkuList(product));
    product._q = parts.join(' ').toLowerCase();
    return product._q;
  }

  function vehicleKey() {
    if (state.allProducts || isMerchCatalog()) return '__all__';
    return state.ymm || '';
  }

  function vehicleLabel() {
    if (state.allProducts) return 'All products';
    if (isMerchCatalog()) return 'Merchandise';
    return state.vehicle || '';
  }

  function ensureSearchPool() {
    var key = vehicleKey();
    if (searchPoolYmm === key && searchPool.length) return searchPool;
    searchPool = vehicleProducts();
    var i;
    for (i = 0; i < searchPool.length; i++) {
      productSkuList(searchPool[i]);
      productSearchText(searchPool[i]);
    }
    searchPoolYmm = key;
    return searchPool;
  }

  function rawSearchTokens(query) {
    return String(query || '')
      .toLowerCase()
      .replace(/[^\w.\-]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function vehicleIgnoreTokens() {
    var ignore = {};
    var bits = [state.vehicle, state.ymm];
    var mapped = state.ymm ? ymmByToken[state.ymm] : null;
    if (mapped) {
      bits.push(mapped.year, mapped.make, mapped.model, mapped.label, mapped.ymm);
    }
    rawSearchTokens(bits.join(' ')).forEach(function (token) {
      ignore[token] = true;
    });
    return ignore;
  }

  function searchTokens(query) {
    var ignore = vehicleIgnoreTokens();
    return rawSearchTokens(query).filter(function (token) {
      return !SEARCH_STOP[token] && !ignore[token];
    });
  }

  function tokenMatches(hay, token) {
    if (hay.indexOf(token) !== -1) return true;
    if (token.length > 3 && token.charAt(token.length - 1) === 's' && hay.indexOf(token.slice(0, -1)) !== -1) {
      return true;
    }
    return false;
  }

  function skuMatches(product, query) {
    var compact = String(query || '').toLowerCase().replace(/[\s\-]/g, '');
    if (!compact) return false;
    var skus = productSkuList(product);
    var i;
    var skuCompact;
    for (i = 0; i < skus.length; i++) {
      skuCompact = skus[i].replace(/[\s\-]/g, '');
      if (skuCompact === compact) return true;
      if (compact.length >= 4 && skuCompact.indexOf(compact) !== -1) return true;
    }
    return false;
  }

  function searchProducts(query, pool) {
    var raw = String(query || '').trim();
    if (!raw) return [];
    var tokens = searchTokens(raw);
    var list = pool || ensureSearchPool();
    var out = [];
    var seen = {};
    var i;
    var product;
    var hay;
    var t;
    var match;

    for (i = 0; i < list.length; i++) {
      product = list[i];
      if (skuMatches(product, raw)) {
        seen[product.id] = true;
        out.push(product);
      }
    }

    if (!tokens.length) return out;

    for (i = 0; i < list.length; i++) {
      product = list[i];
      if (seen[product.id]) continue;
      hay = product._q || productSearchText(product);
      match = true;
      for (t = 0; t < tokens.length; t++) {
        if (!tokenMatches(hay, tokens[t])) {
          match = false;
          break;
        }
      }
      if (match) out.push(product);
    }
    return out;
  }

  function hasSearchQuery() {
    return String(state.query || '').trim().length > 0;
  }

  function browseSourceProducts() {
    if (state.mode === 'search') {
      return hasSearchQuery() ? searchProducts(state.query) : [];
    }
    var inCategory = categoryProducts();
    if (!hasSearchQuery()) return inCategory;
    return searchProducts(state.query, inCategory);
  }

  function filteredProducts() {
    return browseSourceProducts().filter(function (product) {
      if (state.vendor && product.vendor !== state.vendor) return false;
      if (state.type && product.type !== state.type) return false;
      if (state.size && !productHasSize(product, state.size)) return false;
      return true;
    });
  }

  function rebuildYmmIndex() {
    ymmIndex = {};
    Object.keys(ymmByToken).forEach(function (token) {
      var row = ymmByToken[token];
      var year = String(row.year || '');
      var make = row.make || DEFAULT_MAKE;
      var model = row.model || '';
      if (!year || !model) return;
      if (!ymmIndex[year]) ymmIndex[year] = {};
      if (!ymmIndex[year][make]) ymmIndex[year][make] = {};
      ymmIndex[year][make][model] = token;
    });
  }

  function fillSelect(select, placeholder, names, valueMap) {
    if (!select) return;
    select.innerHTML = '<option value="">' + escapeHtml(placeholder) + '</option>';
    (names || []).forEach(function (name) {
      var option = document.createElement('option');
      option.value = valueMap ? valueMap[name] : name;
      option.textContent = name;
      select.appendChild(option);
    });
  }

  function readLastVehicle() {
    try {
      var raw = window.localStorage.getItem(LAST_VEHICLE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.year || !data.make || !data.ymm) return null;
      return {
        year: String(data.year),
        make: String(data.make),
        ymm: String(data.ymm)
      };
    } catch (err) {
      return null;
    }
  }

  function writeLastVehicle(payload) {
    if (!payload || !payload.year || !payload.make || !payload.ymm) return;
    try {
      window.localStorage.setItem(LAST_VEHICLE_KEY, JSON.stringify({
        year: payload.year,
        make: payload.make,
        ymm: payload.ymm
      }));
    } catch (err) {
      /* private mode / quota — fail silent */
    }
  }

  function restoreLastVehicle() {
    var saved = readLastVehicle();
    if (!saved || !yearEl || !ymmIndex[saved.year]) return;
    yearEl.value = saved.year;
    fillMakes();
    if (!makeEl || !ymmIndex[saved.year][saved.make]) return;
    makeEl.value = saved.make;
    fillModels();
    if (!modelEl) return;
    var match = Array.prototype.some.call(modelEl.options, function (option) {
      return option.value === saved.ymm;
    });
    if (match) modelEl.value = saved.ymm;
  }

  function fillYears() {
    var years = Object.keys(ymmIndex).sort().reverse();
    fillSelect(yearEl, 'Select Year', years);
    fillMakes();
  }

  function fillMakes() {
    var year = yearEl ? yearEl.value : '';
    var makes = year && ymmIndex[year] ? Object.keys(ymmIndex[year]).sort() : [];
    fillSelect(makeEl, 'Select Make', makes);
    if (makeEl) makeEl.disabled = !makes.length;
    if (makes.length === 1 && makeEl) makeEl.value = makes[0];
    fillModels();
  }

  function fillModels() {
    var year = yearEl ? yearEl.value : '';
    var make = makeEl ? makeEl.value : '';
    var modelsMap = year && make && ymmIndex[year] && ymmIndex[year][make] ? ymmIndex[year][make] : {};
    var names = Object.keys(modelsMap).sort();
    fillSelect(modelEl, 'Select Model', names, modelsMap);
    if (modelEl) modelEl.disabled = !names.length;
    if (names.length === 1 && modelEl) modelEl.value = modelsMap[names[0]];
  }

  function setNotice(message, isError) {
    if (!noticeEl) return;
    noticeEl.textContent = message || '';
    noticeEl.classList.toggle('is-error', !!isError && !!message);
  }

  function setScreen(name) {
    state.screen = name;
    root.querySelectorAll('[data-sr-screen]').forEach(function (screen) {
      var active = screen.getAttribute('data-sr-screen') === name;
      screen.classList.toggle('is-active', active);
      screen.hidden = !active;
    });
    if (backEl) {
      if (isMerchCatalog()) {
        backEl.hidden = name !== 'products';
        if (backLabelEl) backLabelEl.textContent = 'Categories';
      } else {
        backEl.hidden = name === 'ymm';
        if (backLabelEl) {
          backLabelEl.textContent = name === 'products' && state.ymm && !state.allProducts
            ? 'Categories'
            : 'Vehicle';
        }
      }
    }
  }

  function setVehicleLabels() {
    var label = vehicleLabel();
    vehicleEls.forEach(function (el) {
      el.textContent = label;
    });
  }

  function buildCategories() {
    var buckets = {};
    vehicleProducts().forEach(function (product) {
      productCategories(product).forEach(function (category) {
        if (!buckets[category]) {
          buckets[category] = {
            name: category,
            label: categoryLabel(category),
            count: 0,
            image: ''
          };
        }
        buckets[category].count += 1;
        if (!buckets[category].image && product.image) buckets[category].image = absUrl(product.image);
      });
    });
    if (isMerchCatalog()) {
      return MERCH_TYPES.filter(function (spec) {
        return buckets[spec.type];
      }).map(function (spec) {
        return buckets[spec.type];
      });
    }
    return Object.keys(buckets)
      .sort(function (a, b) {
        if (a === OTHER_CATEGORY) return 1;
        if (b === OTHER_CATEGORY) return -1;
        return a.localeCompare(b);
      })
      .map(function (key) {
        return buckets[key];
      });
  }

  function searchTileHtml() {
    return (
      '<button type="button" class="sm-sr-cat sm-sr-cat--search" data-sr-search-tile>' +
        '<span class="sm-sr-cat__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M16 16l5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</span>' +
        '<span class="sm-sr-cat__label">' +
          'Shop By Search' +
          '<span class="sm-sr-cat__meta">Name, brand, or type</span>' +
        '</span>' +
      '</button>'
    );
  }

  function renderCategories() {
    setVehicleLabels();
    if (!catsEl) return;
    var list = buildCategories();
    if (catsEmptyEl) catsEmptyEl.hidden = true;
    catsEl.innerHTML = searchTileHtml() + list.map(function (bucket) {
      var img = bucket.image
        ? '<img src="' + escapeHtml(bucket.image) + '" alt="" loading="lazy">'
        : '';
      var bg = bucket.image ? ' style="background-image:url(\'' + escapeHtml(bucket.image) + '\')"' : '';
      var label = bucket.label || bucket.name;
      return (
        '<button type="button" class="sm-sr-cat" data-sr-category="' + escapeHtml(bucket.name) + '"' + bg + '>' +
          img +
          '<span class="sm-sr-cat__label">' +
            escapeHtml(label) +
            '<span class="sm-sr-cat__meta">' + bucket.count + (bucket.count === 1 ? ' item' : ' items') + '</span>' +
          '</span>' +
        '</button>'
      );
    }).join('');
  }

  function renderSizeOptions() {
    var showSize = isMerchSizeCategory();
    if (sizeFilterEl) sizeFilterEl.hidden = !showSize;
    if (!showSize) {
      state.size = '';
      fillSelect(sizeEl, 'All sizes', []);
      return;
    }
    var sizes = uniqueSizes(browseSourceProducts().reduce(function (list, product) {
      return list.concat(productAvailableSizes(product));
    }, []));
    if (state.size && sizes.indexOf(state.size) === -1) state.size = '';
    fillSelect(sizeEl, 'All sizes', sizes);
    if (sizeEl) sizeEl.value = state.size || '';
  }

  function renderVendorOptions() {
    if (vendorFilterEl) vendorFilterEl.hidden = isMerchCatalog();
    if (isMerchCatalog()) state.vendor = '';
    if (!vendorEl) return;
    if (isMerchCatalog()) {
      fillSelect(vendorEl, 'All brands', []);
      return;
    }
    var vendors = uniqueSorted(browseSourceProducts().map(function (product) {
      return product.vendor;
    }));
    if (state.vendor && vendors.indexOf(state.vendor) === -1) state.vendor = '';
    fillSelect(vendorEl, 'All brands', vendors);
    vendorEl.value = state.vendor || '';
  }

  function renderTypePills() {
    if (isMerchCatalog() && state.mode === 'category') {
      state.type = '';
      if (typeFilterEl) typeFilterEl.hidden = true;
      if (typesEl) typesEl.innerHTML = '';
      fillSelect(typeSelectEl, 'All', []);
      return;
    }
    var source = browseSourceProducts().filter(function (product) {
      return !state.vendor || product.vendor === state.vendor;
    });
    var types = uniqueSorted(source.map(function (product) {
      return product.type;
    }).filter(Boolean));
    var showTypes = types.length > 0;
    if (state.mode === 'search') {
      showTypes = types.length > 0 && (isPhone() || types.length <= SEARCH_TYPE_PILL_MAX);
    }
    if (typeFilterEl) typeFilterEl.hidden = !showTypes;
    if (!showTypes) {
      if (state.mode === 'search') state.type = '';
      if (typesEl) typesEl.innerHTML = '';
      fillSelect(typeSelectEl, 'All', []);
      return;
    }
    if (state.type && types.indexOf(state.type) === -1) state.type = '';
    fillSelect(typeSelectEl, 'All', types);
    if (typeSelectEl) typeSelectEl.value = state.type || '';
    if (!typesEl) return;
    var html = '<button type="button" class="sm-sr-pill' + (!state.type ? ' is-active' : '') + '" data-sr-type="">All</button>';
    html += types.map(function (type) {
      return (
        '<button type="button" class="sm-sr-pill' + (state.type === type ? ' is-active' : '') + '" data-sr-type="' +
        escapeHtml(type) + '">' + escapeHtml(type) + '</button>'
      );
    }).join('');
    typesEl.innerHTML = html;
  }

  function searchIdleImages() {
    var seen = {};
    var out = [];
    function add(image, name) {
      var src = absUrl(image);
      if (!src || seen[src] || out.length >= 8) return;
      seen[src] = true;
      out.push({ image: src, name: name || '' });
    }
    buildCategories().forEach(function (bucket) {
      add(bucket.image, bucket.label || bucket.name);
    });
    if (out.length < 4) {
      vehicleProducts().forEach(function (product) {
        add(product.image, categoryLabel(productCategories(product)[0] || ''));
      });
    }
    return out;
  }

  function renderSearchIdle() {
    if (!searchIdleTilesEl) return;
    var key = vehicleKey();
    if (searchIdleKey === key && searchIdleTilesEl.childNodes.length) return;
    searchIdleTilesEl.innerHTML = searchIdleImages().map(function (tile) {
      return (
        '<div class="sm-sr-search-idle__tile">' +
          '<img src="' + escapeHtml(tile.image) + '" alt="" draggable="false">' +
          (tile.name ? '<span>' + escapeHtml(tile.name) + '</span>' : '') +
        '</div>'
      );
    }).join('');
    searchIdleKey = key;
  }

  function setSearchIdle(on) {
    if (browseEl) browseEl.classList.toggle('is-search-idle', !!on);
    if (searchIdleEl) searchIdleEl.hidden = !on;
    if (on) renderSearchIdle();
  }

  function syncBrowseMode() {
    var isSearch = state.mode === 'search';
    if (browseEl) browseEl.classList.toggle('is-search', isSearch);
    if (railSearchEl) railSearchEl.hidden = false;
    if (railFiltersEl) {
      if (isMerchCatalog() && !isSearch) {
        railFiltersEl.hidden = !isMerchSizeCategory();
      } else {
        railFiltersEl.hidden = isSearch && !hasSearchQuery();
      }
    }
    if (searchEl) {
      searchEl.placeholder = isSearch ? 'Name, brand, or type' : 'Search this category';
    }
  }

  function renderProductCards(list) {
    return list.map(function (product) {
      var src = absUrl(product.image);
      var mediaStyle = src ? ' style="background-image:url(\'' + escapeHtml(src) + '\')"' : '';
      var img = src
        ? '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(product.title) + '">'
        : '<span class="sm-sr-card__ph" aria-hidden="true"></span>';
      return (
        '<button type="button" class="sm-sr-card" data-sr-details="' + escapeHtml(String(product.id)) + '">' +
          '<span class="sm-sr-card__inner">' +
            '<span class="sm-sr-card__media"' + mediaStyle + '>' + img + '</span>' +
            '<span class="sm-sr-card__copy">' +
              '<span class="sm-sr-card__title"><span class="sm-sr-card__title-text">' + escapeHtml(product.title) + '</span></span>' +
              '<span class="sm-sr-card__price">' + formatPrice(product) + '</span>' +
            '</span>' +
          '</span>' +
        '</button>'
      );
    }).join('');
  }

  function resetGridPage() {
    state.visibleCount = GRID_PAGE_SIZE;
  }

  function setLoadMoreVisible(visible) {
    if (moreEl) moreEl.hidden = !visible;
  }

  function renderProducts(opts) {
    var append = !!(opts && opts.append);
    var isSearch = state.mode === 'search';
    syncBrowseMode();
    if (railTitleEl) railTitleEl.textContent = isSearch ? 'Search' : categoryLabel(state.category);
    setVehicleLabels();
    if (!isSearch || hasSearchQuery()) {
      renderVendorOptions();
      renderSizeOptions();
      renderTypePills();
    } else if (typeFilterEl) {
      typeFilterEl.hidden = true;
      if (sizeFilterEl) sizeFilterEl.hidden = true;
    }

    if (!gridEl) return;
    if (isSearch && !hasSearchQuery()) {
      state.vendor = '';
      state.type = '';
      state.size = '';
      state.visibleCount = GRID_PAGE_SIZE;
      gridEl.innerHTML = '';
      if (countEl) countEl.textContent = '';
      if (emptyEl) emptyEl.hidden = true;
      setLoadMoreVisible(false);
      setSearchIdle(true);
      return;
    }

    setSearchIdle(false);

    var list = filteredProducts();
    var limit = state.visibleCount || GRID_PAGE_SIZE;
    if (limit < GRID_PAGE_SIZE) limit = GRID_PAGE_SIZE;
    state.visibleCount = limit;
    var shown = list.slice(0, limit);

    if (countEl) {
      countEl.textContent = shown.length < list.length
        ? 'Showing ' + shown.length + ' of ' + list.length + ' products'
        : list.length + (list.length === 1 ? ' product' : ' products');
    }

    if (!list.length) {
      gridEl.innerHTML = '';
      setLoadMoreVisible(false);
      if (emptyEl) {
        emptyEl.hidden = false;
        emptyEl.textContent = hasSearchQuery()
          ? 'No products match this search.'
          : 'No products match these filters.';
      }
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    if (append && gridEl.children.length) {
      var already = gridEl.querySelectorAll('[data-sr-details]').length;
      if (already < shown.length) {
        gridEl.insertAdjacentHTML('beforeend', renderProductCards(list.slice(already, shown.length)));
      }
    } else {
      gridEl.innerHTML = renderProductCards(shown);
    }
    setLoadMoreVisible(shown.length < list.length);
  }

  function findProductById(id) {
    var target = String(id || '');
    for (var i = 0; i < products.length; i++) {
      if (String(products[i].id) === target) return products[i];
    }
    return null;
  }

  function productImages(product) {
    var images = Array.isArray(product.images) ? product.images.filter(Boolean).map(absUrl) : [];
    if (!images.length && product.image) images = [absUrl(product.image)];
    return images;
  }

  function formatPrice(product, variant) {
    var price = variant && variant.price ? variant.price : product.price || '';
    var compare = product.compareAt || '';
    if (compare && product.compareAtCents && product.priceCents && product.compareAtCents > product.priceCents) {
      return escapeHtml(price) + ' <s>' + escapeHtml(compare) + '</s>';
    }
    return escapeHtml(price);
  }

  function cleanDescription(html) {
    var raw = String(html || '').trim();
    if (!raw) return '';
    var wrap = document.createElement('div');
    wrap.innerHTML = raw;
    var overview = null;
    var headings = wrap.querySelectorAll('h1, h2, h3, h4, h5, h6, p, strong');
    for (var i = 0; i < headings.length; i++) {
      var text = String(headings[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (/^overview$/i.test(text)) {
        overview = headings[i];
        break;
      }
    }
    if (!overview) return raw;
    var keep = [];
    var node = overview.nextSibling;
    while (node) {
      keep.push(node);
      node = node.nextSibling;
    }
    if (!keep.length && overview.parentNode && overview.parentNode !== wrap) {
      node = overview.nextSibling;
      while (node) {
        keep.push(node);
        node = node.nextSibling;
      }
      node = overview.parentNode.nextSibling;
      while (node) {
        keep.push(node);
        node = node.nextSibling;
      }
    }
    var out = document.createElement('div');
    keep.forEach(function (el) {
      out.appendChild(el.cloneNode(true));
    });
    return out.innerHTML.trim() || raw;
  }

  function renderReviews(product) {
    if (!lightboxReviewsEl) return;
    var count = Number(product && product.ratingCount ? product.ratingCount : 0);
    var rating = Number(product && product.rating ? product.rating : 0);
    if (!count) {
      lightboxReviewsEl.hidden = true;
      lightboxReviewsEl.removeAttribute('aria-label');
      lightboxReviewsEl.innerHTML = '';
      return;
    }
    var stars = '<span class="sm-sr-stars" aria-hidden="true">';
    for (var i = 1; i <= 5; i++) {
      var fill = Math.max(0, Math.min(1, rating - (i - 1)));
      stars +=
        '<span class="sm-sr-star">' +
          '<span class="sm-sr-star__base">' + STAR_SVG + '</span>' +
          '<span class="sm-sr-star__fill" style="width:' + (fill * 100) + '%">' + STAR_SVG + '</span>' +
        '</span>';
    }
    stars += '</span>';
    lightboxReviewsEl.innerHTML =
      stars +
      '<span class="sm-sr-lightbox__reviews-count">' +
        count + (count === 1 ? ' review' : ' reviews') +
      '</span>';
    lightboxReviewsEl.setAttribute(
      'aria-label',
      (rating ? rating.toFixed(1) + ' out of 5 from ' : '') + count + (count === 1 ? ' review' : ' reviews')
    );
    lightboxReviewsEl.hidden = false;
  }

  function renderLightboxThumbs(product) {
    if (!lightboxThumbsEl) return;
    var images = productImages(product);
    if (images.length > 1) {
      lightboxThumbsEl.hidden = false;
      lightboxThumbsEl.innerHTML = images.map(function (src, index) {
        return (
          '<button type="button" class="' + (index === 0 ? 'is-active' : '') + '" data-sr-thumb="' + escapeHtml(src) + '">' +
            '<img src="' + escapeHtml(src) + '" alt="">' +
          '</button>'
        );
      }).join('');
    } else {
      lightboxThumbsEl.innerHTML = '';
      lightboxThumbsEl.hidden = true;
    }
  }

  function setLightboxDescription(html) {
    if (!lightboxDescEl) return;
    var cleaned = cleanDescription(html);
    lightboxDescEl.innerHTML = cleaned || '<p>No description available for this product.</p>';
  }

  function parseJsonResponse(res) {
    if (!res.ok) throw new Error('product');
    return res.text().then(function (text) {
      return JSON.parse(text);
    });
  }

  function fetchProductDetail(product) {
    var handle = product && product.handle ? product.handle : '';
    if (!handle) return Promise.reject(new Error('handle'));
    var viewUrl = '/products/' + encodeURIComponent(handle) + '?view=showroom-json';
    var ajaxUrl = '/products/' + encodeURIComponent(handle) + '.js';
    return fetch(viewUrl, { credentials: 'same-origin' })
      .then(parseJsonResponse)
      .catch(function () {
        return fetch(ajaxUrl, { credentials: 'same-origin' }).then(parseJsonResponse);
      });
  }

  function setLightboxImage(src, alt) {
    if (!lightboxImageEl) return;
    if (src) {
      lightboxImageEl.src = src;
      lightboxImageEl.alt = alt || '';
      lightboxImageEl.style.display = '';
    } else {
      lightboxImageEl.removeAttribute('src');
      lightboxImageEl.alt = '';
      lightboxImageEl.style.display = 'none';
    }
  }

  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxEl.classList.remove('is-open');
    lightboxEl.hidden = true;
    if (lightboxLastFocus && typeof lightboxLastFocus.focus === 'function') {
      lightboxLastFocus.focus();
    }
    lightboxLastFocus = null;
  }

  function openLightbox(productId) {
    var product = findProductById(productId);
    if (!product || !lightboxEl) return;
    state.lightboxProductId = product.id;
    lightboxLastFocus = document.activeElement;

    var images = productImages(product);
    setLightboxImage(images[0] || absUrl(product.image), product.title);
    renderLightboxThumbs(product);

    if (lightboxVendorEl) lightboxVendorEl.textContent = product.vendor || 'Product details';
    if (lightboxTitleEl) lightboxTitleEl.textContent = product.title || '';
    renderReviews(product);
    if (lightboxScrollEl) lightboxScrollEl.scrollTop = 0;

    var variants = Array.isArray(product.variants) ? product.variants.filter(function (variant) {
      return variant && variant.available;
    }) : [];
    var selectedVariant = null;
    if (state.size) {
      selectedVariant = variants.filter(function (variant) {
        return String(variant.title || '').trim() === state.size;
      })[0] || null;
    }
    if (!selectedVariant) {
      selectedVariant = variants.filter(function (variant) {
        return String(variant.id) === String(product.variantId);
      })[0] || variants[0] || null;
    }
    if (lightboxPriceEl) lightboxPriceEl.innerHTML = formatPrice(product, selectedVariant);
    if (lightboxVariantEl && lightboxVariantWrap) {
      if (variants.length > 1) {
        lightboxVariantWrap.hidden = false;
        lightboxVariantEl.hidden = false;
        lightboxVariantEl.innerHTML = variants.map(function (variant) {
          return '<option value="' + escapeHtml(String(variant.id)) + '">' + escapeHtml(variant.title) + ' — ' + escapeHtml(variant.price) + '</option>';
        }).join('');
        lightboxVariantEl.value = String(selectedVariant ? selectedVariant.id : (product.variantId || variants[0].id));
      } else {
        lightboxVariantWrap.hidden = true;
        lightboxVariantEl.hidden = true;
        lightboxVariantEl.innerHTML = '';
      }
    }

    if (lightboxDescEl) {
      var html = String(product.description || '').trim();
      if (html) {
        setLightboxDescription(html);
      } else if (product.handle) {
        lightboxDescEl.innerHTML = '<p>Loading description…</p>';
        fetchProductDetail(product)
          .then(function (detail) {
            if (String(state.lightboxProductId) !== String(product.id)) return;
            product.description = detail && detail.description ? detail.description : '';
            setLightboxDescription(product.description);
            if (detail && Array.isArray(detail.images) && detail.images.length) {
              product.images = detail.images;
              if (!images.length) setLightboxImage(absUrl(detail.images[0]), product.title);
              renderLightboxThumbs(product);
            }
          })
          .catch(function () {
            if (String(state.lightboxProductId) !== String(product.id)) return;
            setLightboxDescription('');
          });
      } else {
        setLightboxDescription('');
      }
    }

    if (lightboxAtcEl) {
      var variantId = (selectedVariant && selectedVariant.id) || product.variantId || (variants[0] && variants[0].id) || '';
      lightboxAtcEl.setAttribute('data-sr-atc', String(variantId));
      lightboxAtcEl.disabled = !variantId;
      lightboxAtcEl.textContent = 'Add to cart';
      lightboxAtcEl.classList.remove('is-added');
    }

    lightboxEl.hidden = false;
    lightboxEl.classList.add('is-open');
    var closeBtn = lightboxEl.querySelector('.sm-sr-lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function currentLightboxVariantId() {
    if (lightboxVariantEl && !lightboxVariantEl.hidden && lightboxVariantEl.value) {
      return lightboxVariantEl.value;
    }
    return lightboxAtcEl ? lightboxAtcEl.getAttribute('data-sr-atc') : '';
  }

  function openCartDrawer() {
    try {
      if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
      if (typeof window.SLIDECART_OPEN === 'function') {
        window.setTimeout(function () {
          window.SLIDECART_OPEN();
        }, 250);
        return true;
      }
    } catch (err) {
      /* SlideCart optional */
    }
    return false;
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart');
        return res.json();
      })
      .then(function (cart) {
        var count = cart && cart.item_count ? Number(cart.item_count) : 0;
        if (!cartCountEl) return;
        cartCountEl.textContent = String(count);
        cartCountEl.hidden = count < 1;
      })
      .catch(function () {
        /* badge is optional */
      });
  }

  function stampShowroomOrder() {
    var attrs = {};
    attrs[SHOP_CART_KEY] = SHOP_ORDER_TAG;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {
      /* order stamp is best-effort */
    });
  }

  function addToCart(variantId, btn) {
    if (!variantId || !btn || btn.disabled) return;
    var original = btn.textContent;
    var props = {};
    props[SHOP_CART_KEY] = SHOP_ORDER_TAG;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, properties: props }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function () {
        stampShowroomOrder();
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('theme:cart:change'));
        refreshCartCount();
        openCartDrawer();
        window.setTimeout(function () {
          btn.textContent = original || 'Add to cart';
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
        window.setTimeout(function () {
          btn.textContent = original || 'Add to cart';
        }, 1600);
      });
  }

  function dedupeProducts() {
    var seen = {};
    products = products.filter(function (product) {
      var id = String(product.id);
      if (seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }

  function setLoadMessage(message) {
    var text = message || '';
    var hide = !text;
    if (loadEl) {
      loadEl.hidden = hide;
      loadEl.textContent = text;
    }
    if (catsLoadEl) {
      catsLoadEl.hidden = hide || !isMerchCatalog();
      catsLoadEl.textContent = isMerchCatalog() ? text : '';
    }
  }

  function setContinueEnabled(enabled) {
    if (continueEl) {
      continueEl.disabled = !enabled;
      continueEl.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      continueEl.setAttribute('aria-busy', enabled ? 'false' : 'true');
    }
    if (searchAllEl) {
      searchAllEl.disabled = !enabled;
      searchAllEl.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    }
  }

  function loadCatalog() {
    var pageSize = config.pageSize || 250;
    var handle = config.collectionHandle || 'all-products-inventory';
    var knownCount = Number(config.productsCount) || 0;
    var startedAt = (window.performance && performance.now) ? performance.now() : Date.now();
    var pagesRequested = 0;
    var pagesLoaded = 0;
    var pagesFailed = 0;

    setContinueEnabled(false);
    setLoadMessage('Loading products… 0%');

    function nowMs() {
      return (window.performance && performance.now) ? performance.now() : Date.now();
    }

    function ingest(batch) {
      if (!batch.length) return;
      products = products.concat(batch);
      dedupeProducts();
      if (state.screen === 'categories') renderCategories();
      if (state.screen === 'products') renderProducts();
    }

    function progressMessage() {
      var total = pagesRequested || (knownCount > 0 ? Math.max(1, Math.ceil(knownCount / pageSize)) : 0);
      var pct = total ? Math.min(100, Math.round((pagesLoaded / total) * 100)) : 0;
      return 'Loading products… ' + pct + '%';
    }

    function fetchPage(page) {
      pagesRequested += 1;
      var url = '/collections/' + encodeURIComponent(handle) + '?view=showroom-json&page=' + page;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Showroom catalog request failed');
          return res.text();
        })
        .then(function (text) {
          var batch = [];
          try {
            batch = JSON.parse(text);
          } catch (err) {
            throw new Error('Showroom catalog JSON invalid');
          }
          if (!Array.isArray(batch)) batch = [];
          pagesLoaded += 1;
          ingest(batch);
          setLoadMessage(progressMessage());
          return { page: page, batch: batch, failed: false };
        })
        .catch(function () {
          pagesFailed += 1;
          return { page: page, batch: [], failed: true };
        });
    }

    function fetchRange(fromPage, toPage) {
      var jobs = [];
      var p;
      for (p = fromPage; p <= toPage; p += 1) {
        jobs.push(fetchPage(p));
      }
      return Promise.all(jobs);
    }

    function finish() {
      catalogReady = products.length > 0;
      catalogError = products.length === 0;
      setContinueEnabled(catalogReady);
      var ms = Math.round(nowMs() - startedAt);
      if (typeof console !== 'undefined' && console.info) {
        console.info(
          '[showroom] catalog loaded',
          products.length + ' products in ' + ms + 'ms',
          '(' + pagesLoaded + '/' + pagesRequested + ' pages' +
            (pagesFailed ? ', ' + pagesFailed + ' failed' : '') + ')',
          handle,
          config.collectionSource || 'fallback'
        );
      }
      if (catalogReady) {
        setLoadMessage('');
      } else {
        setLoadMessage('Unable to load inventory. Refresh and try again.');
      }
      if (state.screen === 'categories') renderCategories();
      if (state.screen === 'products') renderProducts();
    }

    var firstCount = knownCount > 0 ? Math.max(1, Math.ceil(knownCount / pageSize)) : 12;

    function loadFrom(startPage, count) {
      return fetchRange(startPage, startPage + count - 1).then(function (results) {
        var last = results[results.length - 1];
        var lastFull = last && !last.failed && last.batch.length >= pageSize;
        var anyOk = results.some(function (result) { return !result.failed; });
        if (lastFull) return loadFrom(startPage + count, 2);
        if (!anyOk && startPage === 1) throw new Error('Showroom catalog request failed');
      });
    }

    return loadFrom(1, firstCount)
      .then(finish)
      .catch(function () {
        catalogReady = products.length > 0;
        catalogError = products.length === 0;
        setContinueEnabled(catalogReady);
        setLoadMessage(catalogReady ? '' : 'Unable to load inventory. Refresh and try again.');
      });
  }

  function resetBrowseState() {
    state.category = null;
    state.mode = 'category';
    state.query = '';
    state.vendor = '';
    state.type = '';
    state.size = '';
    resetGridPage();
    if (searchEl) searchEl.value = '';
    setSearchIdle(false);
  }

  function enterMerchHome() {
    state.ymm = null;
    state.vehicle = '';
    state.allProducts = false;
    resetBrowseState();
    searchPool = [];
    searchPoolYmm = '';
    searchIdleKey = '';
    setSearchIdle(false);
    renderCategories();
    setScreen('categories');
    setNotice('', false);
  }

  function goToYmm() {
    if (isMerchCatalog()) {
      enterMerchHome();
      return;
    }
    state.ymm = null;
    state.vehicle = '';
    state.allProducts = false;
    resetBrowseState();
    searchPool = [];
    searchPoolYmm = '';
    searchIdleKey = '';
    setSearchIdle(false);
    setScreen('ymm');
    setNotice('', false);
  }

  function goToCategories() {
    if (isMerchCatalog()) {
      enterMerchHome();
      return;
    }
    if (!catalogReady) {
      setNotice(catalogError ? 'Unable to load inventory. Refresh and try again.' : 'Loading products…', catalogError);
      return;
    }
    resetBrowseState();
    renderCategories();
    setScreen('categories');
    setNotice('', false);
  }

  function goToProducts(category) {
    state.mode = 'category';
    state.category = category;
    state.query = '';
    state.vendor = '';
    state.type = '';
    state.size = '';
    resetGridPage();
    if (searchEl) searchEl.value = '';
    renderProducts();
    setScreen('products');
  }

  function goToSearch() {
    state.mode = 'search';
    state.category = null;
    state.query = '';
    state.vendor = '';
    state.type = '';
    state.size = '';
    resetGridPage();
    if (searchEl) searchEl.value = '';
    ensureSearchPool();
    renderProducts();
    setScreen('products');
    window.setTimeout(function () {
      if (searchEl) searchEl.focus();
    }, 40);
  }

  function goToSearchAll() {
    if (!catalogReady) {
      setNotice(catalogError ? 'Unable to load inventory. Refresh and try again.' : 'Loading products…', catalogError);
      return;
    }
    state.ymm = null;
    state.vehicle = '';
    state.allProducts = true;
    resetBrowseState();
    searchPool = [];
    searchPoolYmm = '';
    searchIdleKey = '';
    goToSearch();
    setNotice('', false);
  }

  function applySearchQuery(value) {
    state.query = String(value || '');
    resetGridPage();
    if (searchEl && searchEl.value !== state.query) searchEl.value = state.query;
    if (searchRaf) window.cancelAnimationFrame(searchRaf);
    searchRaf = window.requestAnimationFrame(function () {
      searchRaf = 0;
      renderProducts();
    });
  }

  if (isMerchCatalog()) {
    root.classList.add('is-merch-catalog');
    enterMerchHome();
  } else {
    rebuildYmmIndex();
    fillYears();
    restoreLastVehicle();
  }
  refreshCartCount();
  loadCatalog();

  if (yearEl) {
    yearEl.addEventListener('change', function () {
      fillMakes();
      setNotice('', false);
    });
  }
  if (makeEl) {
    makeEl.addEventListener('change', function () {
      fillModels();
      setNotice('', false);
    });
  }
  if (modelEl) {
    modelEl.addEventListener('change', function () {
      setNotice('', false);
    });
  }

  if (formEl) {
    formEl.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!catalogReady) {
        setNotice(catalogError ? 'Unable to load inventory. Refresh and try again.' : 'Loading products…', catalogError);
        return;
      }
      var year = yearEl ? yearEl.value : '';
      var make = makeEl ? makeEl.value : '';
      var ymmToken = modelEl ? modelEl.value : '';
      var modelLabel = modelEl && modelEl.options[modelEl.selectedIndex]
        ? modelEl.options[modelEl.selectedIndex].textContent
        : '';
      if (!year || !make || !ymmToken) {
        setNotice('Please select your year, make, and model.', true);
        return;
      }
      var mapped = ymmByToken[ymmToken] || {};
      writeLastVehicle({ year: year, make: make, ymm: ymmToken });
      state.ymm = ymmToken;
      state.vehicle = mapped.label || (year + ' ' + make + ' ' + modelLabel);
      state.allProducts = false;
      resetBrowseState();
      goToCategories();
    });
  }

  if (searchAllEl) {
    searchAllEl.addEventListener('click', function () {
      goToSearchAll();
    });
  }

  if (backEl) {
    backEl.addEventListener('click', function () {
      closeLightbox();
      if (state.screen === 'products') {
        if (isMerchCatalog() || (state.ymm && !state.allProducts)) {
          goToCategories();
          return;
        }
        goToYmm();
        return;
      }
      if (isMerchCatalog()) return;
      goToYmm();
    });
  }

  if (cartEl) {
    cartEl.addEventListener('click', function (event) {
      if (openCartDrawer()) event.preventDefault();
    });
  }

  if (catsEl) {
    catsEl.addEventListener('click', function (event) {
      if (event.target.closest('[data-sr-search-tile]')) {
        goToSearch();
        return;
      }
      var button = event.target.closest('[data-sr-category]');
      if (!button) return;
      goToProducts(button.getAttribute('data-sr-category'));
    });
  }

  if (searchFormEl) {
    searchFormEl.addEventListener('submit', function (event) {
      event.preventDefault();
      if (searchEl) applySearchQuery(searchEl.value);
    });
  }

  if (searchEl) {
    searchEl.addEventListener('input', function () {
      applySearchQuery(searchEl.value);
    });
  }

  if (vendorEl) {
    vendorEl.addEventListener('change', function () {
      state.vendor = vendorEl.value || '';
      resetGridPage();
      renderProducts();
    });
  }

  if (sizeEl) {
    sizeEl.addEventListener('change', function () {
      state.size = sizeEl.value || '';
      resetGridPage();
      renderProducts();
    });
  }

  if (typesEl) {
    typesEl.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sr-type]');
      if (!button) return;
      state.type = button.getAttribute('data-sr-type') || '';
      resetGridPage();
      renderProducts();
    });
  }

  if (typeSelectEl) {
    typeSelectEl.addEventListener('change', function () {
      state.type = typeSelectEl.value || '';
      resetGridPage();
      renderProducts();
    });
  }

  if (loadMoreEl) {
    loadMoreEl.addEventListener('click', function () {
      state.visibleCount = (state.visibleCount || GRID_PAGE_SIZE) + GRID_LOAD_MORE;
      renderProducts({ append: true });
    });
  }

  if (gridEl) {
    gridEl.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-sr-details]');
      if (!trigger) return;
      event.preventDefault();
      openLightbox(trigger.getAttribute('data-sr-details'));
    });
  }

  if (lightboxEl) {
    lightboxEl.addEventListener('click', function (event) {
      if (event.target.closest('[data-sr-lightbox-close]')) {
        closeLightbox();
        return;
      }
      var thumb = event.target.closest('[data-sr-thumb]');
      if (thumb) {
        setLightboxImage(thumb.getAttribute('data-sr-thumb'), lightboxTitleEl ? lightboxTitleEl.textContent : '');
        lightboxEl.querySelectorAll('[data-sr-thumb]').forEach(function (btn) {
          btn.classList.toggle('is-active', btn === thumb);
        });
      }
    });
  }

  if (lightboxVariantEl) {
    lightboxVariantEl.addEventListener('change', function () {
      if (lightboxAtcEl) lightboxAtcEl.setAttribute('data-sr-atc', lightboxVariantEl.value);
      var product = findProductById(state.lightboxProductId);
      if (!product) return;
      var variant = (product.variants || []).filter(function (item) {
        return String(item.id) === String(lightboxVariantEl.value);
      })[0];
      if (lightboxPriceEl) lightboxPriceEl.innerHTML = formatPrice(product, variant);
      if (variant && variant.image) setLightboxImage(absUrl(variant.image), product.title);
    });
  }

  if (lightboxAtcEl) {
    lightboxAtcEl.addEventListener('click', function () {
      addToCart(currentLightboxVariantId(), lightboxAtcEl);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLightbox();
  });
})();
